import Vue from 'vue';
import Vuex from 'vuex';
import router from '@/router';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		userInfo: null,
		token: null,
		urole: null,
		userpowers: null,
		isLogin: false,
		projectNavStatus: 'PENDING',
		pageTitles: {},
		needRefresh: false
	},
	mutations: {
		SET_USER_INFO(state, userInfo) {
			state.userInfo = userInfo;
		},
		SET_TOKEN(state, token) {
			state.token = token;
		},
		SET_UROLE(state, urole) {
			state.urole = urole;
		},
		SET_USERPOWERS(state, userpowers) {
			state.userpowers = userpowers;
		},
		SET_LOGIN_STATUS(state, status) {
			state.isLogin = status;
		},
		SET_PROJECT_NAV_STATUS(state, status) {
			state.projectNavStatus = status;
		},
		SET_PAGE_TITLE(state, { routeName, title }) {
			Vue.set(state.pageTitles, routeName, title);
		},
		SET_NEED_REFRESH(state, value) {
			state.needRefresh = value;
		},
		LOGOUT(state) {
			state.userInfo = null;
			state.token = null;
			state.urole = null,
				state.userpowers = null,
				state.isLogin = false;
		}
	},
	actions: {
		login({ commit }, { userInfo, token, urole, userpowers }) {
			commit('SET_USER_INFO', userInfo);
			commit('SET_TOKEN', token); 
			commit('SET_UROLE', urole);
			commit('SET_USERPOWERS', userpowers);
			commit('SET_LOGIN_STATUS', true);
			if (router.setRedirectingToLogin) {
				router.setRedirectingToLogin(false);
			}
		},
		logout({ commit }) {
			commit('LOGOUT');
		},
		setPageTitle({ commit }, { routeName, title }) {
			commit('SET_PAGE_TITLE', { routeName, title });
		},
		setNeedRefresh({ commit }, value) {
			commit('SET_NEED_REFRESH', value);
		}
	},
	getters: {
		userInfo: state => state.userInfo,
		token: state => state.token,
		urole: state => state.urole,
		userpowers: state => state.userpowers,
		isLogin: state => state.isLogin,
		projectNavStatus: state => state.projectNavStatus,
		pageTitles: state => state.pageTitles,
		getPageTitle: state => routeName => state.pageTitles[routeName] || '',
		needRefresh: state => state.needRefresh
	},
	plugins: [
		createPersistedState({
			key: 'jlda-vuex',
			storage: window.localStorage,
			reducer: (state) => ({
				userInfo: state.userInfo,
				token: state.token,
				urole: state.urole,
				userpowers: state.userpowers,
				isLogin: state.isLogin,
				projectNavStatus: state.projectNavStatus,
				pageTitles: state.pageTitles
			})
		})
	]
});
